import {
  RootDiv,
  ImgDiv,
  TextDiv,
  Title,
  InformationText,
} from './InformationBox.styles';

interface InformationBoxProps {
  title?: string;
  information?: React.ReactNode;
  icon?: any;
  padding?: string;
}

export const InformationBox = ({
  title,
  information,
  icon,
}: InformationBoxProps) => {
  return (
    <RootDiv>
      {icon && <ImgDiv>{icon}</ImgDiv>}
      <TextDiv>
        {title && <Title>{title}</Title>}
        {information && <InformationText>{information}</InformationText>}
      </TextDiv>
    </RootDiv>
  );
};
